import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import ReplayIcon from "@mui/icons-material/Replay";

function CircularProgressWithLabel({
  progressStep,
  value,
  handleTryAgain,
  ...props
}) {
  const [progress, setProgress] = useState(0);
  const [finalColor, setFinalColor] = useState("primary.main"); // Default color during animation
  const [showTextAndIcon, setShowTextAndIcon] = useState(false);
  const [showResultTextAndIcon, setShowResultTextAndIcon] = useState(false);
  console.log(progressStep);
  useEffect(() => {
    const stepInterval = setInterval(() => {
      if (progress < value) {
        setProgress((prev) => prev + progressStep);
      } else {
        clearInterval(stepInterval);
        // Set the final color based on the percentage
        setFinalColor(value >= 80 ? "green" : "#f4722f");
        setShowTextAndIcon(true);
        setShowResultTextAndIcon(true);
      }
    }, 100);

    return () => clearInterval(stepInterval);
  }, [progress, value, progressStep]);

  return (
    <Box>
      <Box style={{ position: "relative", display: "inline-block" }}>
        {/* Background CircularProgress */}
        <CircularProgress
          variant="determinate"
          value={100}
          size={300}
          thickness={1}
          sx={{ color: "grey" }}
        />

        {/* Foreground CircularProgress */}
        <CircularProgress
          variant="determinate"
          value={progress}
          size={300}
          thickness={1}
          sx={{
            color: progress < value ? "primary.main" : finalColor, // Change color after animation
            position: "absolute",
            top: 0,
            left: 0,
          }}
          {...props}
        />

        {/* Conditional Rendering of Text and Icon */}
        {showTextAndIcon && (
          <Box
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: "bold", lineHeight: 1, marginBottom: 1 }}
            >
              Your Score {isNaN(value) ? "0%" : `${Math.round(value)}%`}
            </Typography>

            {/* Conditional Icon Rendering */}
            {value >= 80 ? (
              <CheckIcon sx={{ fontSize: 129, color: "green" }} />
            ) : (
              <CloseIcon sx={{ fontSize: 129, color: "#f4722f" }} />
            )}
          </Box>
        )}
      </Box>
      {showResultTextAndIcon &&
        (value >= 80 ? (
          <Typography
            variant="h5"
            sx={{ color: "success.main", fontWeight: "bold" }}
          >
            Congratulations !!
          </Typography>
        ) : (
          <>
            <Typography
              variant="body2"
              color="text.secondary"
              fontWeight="bold"
            >
              TAKE AGAIN
            </Typography>
            <ReplayIcon
              onClick={handleTryAgain}
              sx={{
                fontSize: 30,
                cursor: "pointer",
                color: "primary.main",
                "&:hover": {
                  color: "primary.dark",
                },
              }}
            />
          </>
        ))}
    </Box>
  );
}

export default CircularProgressWithLabel;
